
import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton } from '@fluentui/react';

interface Props {
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
}

export default function ConfirmationDialog({ title, message, onConfirm, onCancel }: Props) {
    return (
        <Dialog
            hidden={false}
            onDismiss={onCancel}
            dialogContentProps={{
                type: DialogType.normal,
                title,
                subText: message,
            }}
            modalProps={{ isBlocking: true }}
        >
            <DialogFooter>
                <PrimaryButton text="Confirm" onClick={onConfirm} />
                <DefaultButton text="Cancel" onClick={onCancel} />
            </DialogFooter>
        </Dialog>
    );
}
